import React, {useEffect, useState} from 'react'
import {Modal, Spinner} from 'react-bootstrap'
import {useSelector} from 'react-redux'
import Select from 'react-select'
import {Formik, Field, ErrorMessage, Form} from 'formik'
import {useUpdateSharedNumberMutation} from '../../../../../services/cellcast'
import {toast} from 'react-toastify'
import {GATEWAY_FEATURE_TYPE_OPTIONS} from '../../../../Utils/Constant/ConstantForWebsite'
import {useDispatch} from 'react-redux'
import {GetGatewayManagementList} from '../../../../../app/pages/AdminPages/GatewayManagement/GatewayManagementSlice/GatewayManagementSlice'

const EditSharedNumber = ({data, setData, show, handleClose, refetch, page}: any) => {
  const dispatch = useDispatch()
  const paymentGatewayList = useSelector((state: any) => state?.paymentGateway?.GatewayManagement)

  const [updateSharedNumber] = useUpdateSharedNumberMutation()

  useEffect(() => {
    if (show) {
      dispatch(GetGatewayManagementList())
      setEditNumberData(data)
    }
  }, [show, data])

  const [editNumberData, setEditNumberData] = useState<any>(data)

  const handleSubmit = async (value: any) => {
    try {
      const result = await updateSharedNumber(value).unwrap()
      refetch()
      toast.success(result.message)
      handleClose()
    } catch (error) {
      console.error('Error updating shared number:', error)
    }
  }

  return (
    <>
      <Modal
        id='kt_modal_create_app'
        tabIndex={1}
        aria-hidden='true'
        dialogClassName='modal-dialog-centered mw-600px'
        className='vh-100'
        show={show}
        onHide={handleClose}
      >
        <div className='modal-header'>
          <h1>Edit Shared Number</h1>
        </div>
        <div className='modal-body p-20 '>
          <div className='fv-row mb-5'>
            <Formik
              initialValues={editNumberData}
              onSubmit={handleSubmit}
              enableReinitialize={true}
            >
              {({isSubmitting, values, setFieldValue}: any) => (
                <Form>
                  <div>
                    <label className=' col-form-label required fw-bold fs-6' htmlFor='number'>
                      Gateway Number
                    </label>
                    <Field
                      className='form-control form-control-lg form-control-solid mb-3 mb-lg-0'
                      type='text'
                      id='number'
                      name='number'
                      placeholder='Gateway Number'
                    />
                    <ErrorMessage className='text-danger' name='number' component='div' />
                  </div>

                  <div>
                    <label className=' col-form-label required fw-bold fs-6' htmlFor='gateway'>
                      Gateway
                    </label>
                    <Select
                      value={{
                        value:
                          paymentGatewayList?.find((key: any) => key?._id === values?.gateway)
                            ?._id || '',
                        label: `${
                          paymentGatewayList?.find((key: any) => key?._id === values?.gateway)
                            ?.DB || 'Select'
                        }-${
                          paymentGatewayList?.find((key: any) => key?._id === values?.gateway)
                            ?.gatewayName || 'Gateway'
                        }`,
                      }}
                      onChange={(e: any) => setFieldValue('gateway', e.value)}
                      options={[
                        {value: '', label: 'select'},
                        ...paymentGatewayList?.map((key: any, id: number) => ({
                          value: `${key?._id}`,
                          label: `${key?.DB}-${key?.gatewayName}`,
                        })),
                      ]}
                    />
                    <ErrorMessage className='text-danger' name='gateway' component='div' />
                  </div>

                  <div>
                    <label className=' col-form-label required fw-bold fs-6' htmlFor='type'>
                      Type
                    </label>
                    <Select
                      value={{value: values?.type, label: values?.type}}
                      onChange={(e: any) => setFieldValue('type', e?.value)}
                      options={GATEWAY_FEATURE_TYPE_OPTIONS}
                    />
                    <ErrorMessage className='text-danger' name='type' component='div' />
                  </div>

                  <div className='d-flex flex-center mt-5'>
                    <div id='kt_drawer_chat_close'>
                      <button
                        type='button'
                        onClick={() => {
                          handleClose()
                        }}
                        className='btn btn-md gray_bg_purple me-2'
                      >
                        Cancel
                      </button>
                    </div>
                    <button type='submit' className='btn btn-primary' disabled={isSubmitting}>
                      Update
                      {isSubmitting && (
                        <Spinner
                          as='span'
                          animation='grow'
                          size='sm'
                          role='status'
                          className='ms-2'
                        />
                      )}
                    </button>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </div>
      </Modal>
    </>
  )
}

export default EditSharedNumber
